import { render, staticRenderFns } from "./gridRobot.vue?vue&type=template&id=69ab5aa8&scoped=true&"
import script from "./gridRobot.vue?vue&type=script&lang=js&"
export * from "./gridRobot.vue?vue&type=script&lang=js&"
import style0 from "./gridRobot.vue?vue&type=style&index=0&id=69ab5aa8&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69ab5aa8",
  null
  
)

export default component.exports